import React, { useEffect } from "react";
import { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { UserContext } from "./../UserContext";
import NoTenantDashboard from "../NoTenantDashboard/NoTenantDashboard";
import { FeatureNotAvailable } from "../BillingAutomation";
import { UnavailableFeatureForNonDSACEO } from "../UnavailableFeature/UnavailableFeatureForNonDSACEO";

const useStyles = makeStyles((theme) => ({
  screenContainer: {
    paddingBottom: theme.spacing(6),
  },
  container: {
    paddingLeft: 30,
    paddingRight: 30,
  },
}));

export function NoTenantHome() {
  const classes = useStyles();
  const { user } = useContext(UserContext);
  const tenant = user.getTenant();
  const sso = user.getSSO();
  const isSiaaAgency = user.isSiaaAgency();
  const isSSOUser = sso === true || sso === "true" ? true : false;
  const doesNotHaveTenant = isSiaaAgency && isSSOUser && !tenant;

  return (
    <Switch>
      {doesNotHaveTenant && (
        <Route path={`/agencyIQ/feature-not-available`}>
          <UnavailableFeatureForNonDSACEO />
        </Route>
      )}
      {doesNotHaveTenant && (
        <Route path={`/agencyIQ`}>
          <div className={classes.container}>
            <NoTenantDashboard isBasicPlanOrSetup={true} />
          </div>
        </Route>
      )}
    </Switch>
  );
}
